import Box from '@mui/material/Box'
import Iphone1 from 'assets/images/homepage/iphone-home1.webp'
import Iphone2 from 'assets/images/homepage/iphone-home2.webp'
import Iphone3 from 'assets/images/homepage/iphone-home3.webp'
import Iphone4 from 'assets/images/homepage/iphone-home4.webp'
import MobilePresentation from 'components/layouts/common/MobilePresentation/MobilePresentation'
import TextBoxes from 'components/layouts/common/TextBoxes/TextBoxes'
import ScrollLayout from 'components/layouts/ScrollLayout/ScrollLayout'
import Hero from 'components/pages/artists/Hero/Hero'
import SectionArtists from 'components/pages/artists/SectionArtists/SectionArtists'
import Step1 from 'components/pages/artists/SectionSteps/Step1'
import Step2 from 'components/pages/artists/SectionSteps/Step2'
import Step3 from 'components/pages/artists/SectionSteps/Step3'
import type { NextPage } from 'next'
import Head from 'next/head'

const mobilePresentationElements = [
  { title: 'Discover styles', image: Iphone1 },
  { title: 'Find your artist', image: Iphone2 },
  { title: 'Get in touch', image: Iphone3 },
  { title: 'Pay safely in-app', image: Iphone4 },
]

const elements = [
  {
    title: 'Gain more customers',
    content:
      'With the app, you will be able to attract more customers who are right for your business.',
  },
  {
    title: 'All-in-one tool',
    content:
      'Get new customers, contact them, and manage their payments. Everything in one place. ',
  },
  {
    title: 'Use it for free',
    content:
      'We do not believe in subscription fees or premium features. It is free to use for everyone. ',
  },
]

const Search: NextPage = () => {
  return (
    <Box>
      <Head>
        <title>inckd.</title>
        <meta
          name="description"
          content="A place where artists and tattoo lovers meet"
        />
        <link rel="canonical" href="https://inckd.com" />
      </Head>

      <main>
        <ScrollLayout
          background="linear-gradient(0deg, #0E1F39 8.29%, #66119F 83.28%)"
          components={[
            {
              component: <Hero key={1} />,
              scrollTo: 'section-steps',
              button: 'down',
            },
            {
              component: <Step1 key={2} />,
            },
            {
              component: <Step2 key={3} />,
            },
            {
              component: <Step3 key={4} />,
            },
            {
              component: (
                <TextBoxes
                  key={5}
                  title="Your benefits"
                  headline="Effective. Holistic. Free. "
                  elements={elements}
                />
              ),
            },
            {
              component: (
                <MobilePresentation
                  title="Discover features"
                  headline="Dare to change"
                  elements={mobilePresentationElements}
                  key={6}
                />
              ),
            },
            {
              component: <SectionArtists key={7} />,
              scrollTo: 'section-hero',
              button: 'up',
            },
          ]}
        />
      </main>
    </Box>
  )
}

export const getStaticProps = async () => {
  return {
    props: {
      withScroll: true,
    },
  }
}

export default Search
